import RowEditableTable from "../../../../../../components/Tables/RowEditableTable";
import { table4d5dColumns } from "./columns";
import TimelineComponent from "./TimelineComponent";

import {
  getSchedule,
  getTrackItem,
  updateSchedule,
  update4D,
  getProjectData,
} from "./api";

import { Box, Stack } from "@mui/material";

const ScheduleComponent = ({ rows, setRows, projectId, onRowClick }) => {
  const handleSaveCell = (cell, value) => {
    console.log(cell, value);
    let id = cell.row.original.id;
    let column = cell.column.id;
    const updatedRows = rows?.map((row) =>
      row.id === id ? { ...row, [column]: value } : row
    );
    setRows(updatedRows);
    // reRender()
  };
  const handleSaveRow = async (values) => {
    // console.log("vvvvvvvvvvvv", values);
    const body = {
      plannedStart: values.row.original.plannedStart,
      plannedEnd: values.row.original.plannedEnd,
    };
    console.log("bodyy", body);

    await update4D(values.row.original.id, body);
  };
  return (
    <Stack direction={"row"}>
      <Box width={"44vw"}>
        {/* <Project4d5d /> */}
        <RowEditableTable
          columns={table4d5dColumns}
          data={rows}
          // handleCreateRow
          handleSaveRow={handleSaveRow}
          additionalProps={{
            muiTableBodyRowProps: ({ row }) => ({
              onClick: () => onRowClick(row),
              sx: { cursor: "pointer" },
            }),
          }}
          //   onRowClick={onRowClick}
          // enablePagination={false}
          // enableEditing={true}
          // enableColumnActions={false}
          // enableSorting={false}
          // editDisplayMode="cell"
          // enableBottomToolbar={false}
          // enableRowActions={true}
          // positionActionsColumn="last"
          // {...tableWithBorderedCells}
          // renderRowActionMenuItems={({ row }) => [
          //   <MenuItem key="edit" onClick={() => onTrackItem(row)}>
          //     Track Item
          //   </MenuItem>,
          // ]}
          // // muiTableContainerProps={{ sx: { maxHeight: '70vh' } }}
          // muiEditTextFieldProps={({ cell }) => ({
          //   onBlur: (event) => {
          //     handleSaveCell(cell, event.target.value);
          //   },
          // })}
          // renderTopToolbarCustomActions={(table) => (
          //   <Button
          //     variant="contained"
          //     sx={{ alignSelf: "end", width: "fit-content" }}
          //     onClick={onSave}
          //   >
          //     Save
          //   </Button>
          // )}
          // initialState={{ columnPinning: { left: ["name"] } }}
        />
      </Box>
      <Box width={"55vw"}>
        <TimelineComponent projectId={projectId} rows={rows} />
      </Box>
    </Stack>
  );
};

export default ScheduleComponent;
